import Base               from 'src/components/Base'
import Loyalty            from 'src/components/Loyalty'
import Dematerialisation  from 'src/components/Dematerialisation'

export default Dematerialisation(Loyalty(Base))



// WEBPACK FOOTER //
// ./src/AllPublicMethods.js